import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import sv from 'dayjs/locale/sv'

dayjs.locale('sv')
dayjs.extend(timezone)
dayjs.extend(utc)

export function timeToDayJS (date) {
  return dayjs.tz(date, 'UTC').tz('Europe/Stockholm')
}
